<!-- <app-page-header Heading="DB Configuration" Description="">
    <div class="btn btn-sm btn-primary" (click)="openDBConfigForm()">New DB Configuration</div>
</app-page-header>

<app-pagination [EnablePageSize]="true" [rowData]="dbConfigList" (pageSizeChanged)="handlePageSizeChange($event)">
</app-pagination> -->

<div class="d-flex justify-content-between align-items-center w-100">

    <div class="d-flex align-items-center gap-4">
        <app-page-header Heading="DB Configuration" Description="">
        </app-page-header>

        <app-pagination 
            [EnablePageSize]="true" 
            [rowData]="dbConfigList" 
            (pageSizeChanged)="handlePageSizeChange($event)">
        </app-pagination>
    </div>

    <div class="d-flex align-items-center">
        <button class="btn btn-sm btn-primary shadow-sm" (click)="openDBConfigForm()" [disabled]="isLoading">
             New DB Configuration
        </button>
    </div>

</div>

<ng-container *ngIf="isLoading; else dbConfigTableContent">
    <div class="card mb-1">
        <div class="card-header d-flex align-items-center">
            <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
            <span class="ml-2">
                <ngx-skeleton-loader count="1" width="150px" height="16px"></ngx-skeleton-loader>
            </span>
        </div>
        <div class="card-body">
            <ngx-skeleton-loader count="3" width="100%" height="14px" style="margin-bottom: 8px;"></ngx-skeleton-loader>
        </div>
    </div>
</ng-container>

<ng-template #dbConfigTableContent>
    <app-color-table [columns]="[
        {colName:'Connection Name',colData:'connName'},
        {colName:'Server Name',colData:'serverName'},
        {colName:'User Name',colData:'userName'},
        {colName:'DB Name',colData:'dbName'},
        ]" [tableData]="this.dbConfigList" [enableActionColumn]="true" [actionColumnLabel]="'Action'"
        [actionOptions]="[{actionName:'Edit',actionIcon:'fa fa-edit'},{actionName:'Delete',actionIcon:'fa fa-trash'},{actionName:'Reset Password',actionIcon:'fa fa-lock'}]"
        (actionClick)="handleActionClick($event)">
    </app-color-table>
</ng-template>


<app-pagination [EnableNavigation]="true" [rowData]="dbConfigList" (pageSizeChanged)="handlePageSizeChange($event)">
</app-pagination>

<ng-template #dbConfigModalContent>

    <div class="modal-header">
        <h5 class="modal-title">New DB Configuration</h5>
        <button type="button" class="btn-close" (click)="addDBConfigModal.close()"></button>
    </div>
    <div class="modal-body">
        <form [formGroup]="dbConfigForm">

            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="cname">Connection Name</label><span style="color: red;">*</span>
                        <input type="text" class="form-control form-control-sm mt-1"
                            [formControl]="dbConfigForm.controls.cName" placeholder="Connection Name">
                        <app-form-errors [control]="dbConfigForm.controls.cName"></app-form-errors>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="sname">Server Name</label><span style="color: red;">*</span>
                        <input type="text" class="form-control form-control-sm mt-1"
                            [formControl]="dbConfigForm.controls.sName" placeholder="Server Name">
                        <app-form-errors [control]="dbConfigForm.controls.sName"></app-form-errors>
                    </div>
                </div>
            </div>

            <div class="row mt-2">
                <div [ngClass]="isEditMode ? 'col-md-12' : 'col-md-6'">
                    <div class="form-group">
                        <label for="uname">User Name</label><span style="color: red;">*</span>
                        <input type="text" class="form-control form-control-sm mt-1" autocomplete="off"
                            [formControl]="dbConfigForm.controls.uName" placeholder="User Name">
                        <app-form-errors [control]="dbConfigForm.controls.uName"></app-form-errors>
                    </div>
                </div>
                <div class="col-md-6" *ngIf="!isEditMode">
                    <div class="form-group">
                        <label for="name">Password</label><span style="color: red;">*</span>
                        <div class="d-flex  align-items-start">
                            <input [type]="showDBPassword ? 'text' : 'password'"
                                class="form-control form-control-sm mt-1" autocomplete="new-password"
                                [formControl]="dbConfigForm.controls.uPassword" placeholder="Password">

                            <button type="button" class="btn btn-sm  mx-2 my-1 rounded-lg"
                                (click)="showDBPassword = !showDBPassword">
                                <i class="fa" [ngClass]="showDBPassword ? 'fa-eye' : 'fa-eye-slash'"></i>
                            </button>
                        </div>
                        <app-form-errors [control]="dbConfigForm.controls.uPassword"></app-form-errors>
                    </div>
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-md-12">
                    <div class="form-group">
                        <label for="dbName">DB Name</label><span style="color: red;">*</span>
                        <input class="form-control mt-1" [formControl]="dbConfigForm.controls.dbName"
                            placeholder="DB Name">
                        <app-form-errors [control]="dbConfigForm.controls.dbName"></app-form-errors>
                    </div>
                </div>
            </div>

        </form>
    </div>
    <div class="modal-footer mt-3">
        <button type="button" class="btn btn-primary" (click)="submitDBConfigForm()" [disabled]="isLoading">
            <ng-container *ngIf="!isLoading; else loadingContent">Submit</ng-container>
            <ng-template #loadingContent>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Saving...
            </ng-template>
        </button>

        <button type="button" class="btn btn-secondary" (click)="addDBConfigModal.close()">Close</button>
    </div>
</ng-template>



<ng-template #resetDBPasswordModalContent >
    <div class="modal-header">
        <h5 class="modal-title">Reset DB Password - {{ resetDBPasswordForm.get('connName')?.value }} </h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="resetDBPasswordModal.close()"></button>
    </div>

    <div class="modal-body">
        <form [formGroup]="resetDBPasswordForm">
            <div class="mb-3">
                <label class="form-label">User Name</label>
                <input type="text" class="form-control" formControlName="userName" readonly
                    placeholder="User Name">
            </div>
            <div class="mb-3">
                <label class="form-label">New Password</label><span style="color: red;">*</span>
                <input type="password" class="form-control" formControlName="newPassword" autocomplete="new-password"
                    placeholder="Enter New Password">
                <app-form-errors [control]="resetDBPasswordForm.get('newPassword')"
                    fieldName="New Password"></app-form-errors>
            </div>
        </form>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-primary btn-sm" (click)="resetDBPassword()">Submit</button>
        <button type="button" class="btn btn-secondary btn-sm" (click)="resetDBPasswordModal.close()">Cancel</button>
    </div>
</ng-template>